module.exports = __webpack_public_path__ + "img/nvelogo.b7ace172.svg";